const dateHelper = {
  trimDateString(date) {
    return date.substring(0, 10);
  },
  toDateString(date) {
    return date.toISOString().substring(0, 10);
  },
  getDateWithoutTime(d) {
    if (!d) {
      d = new Date();
    }

    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    return d;
  },
  shortString(date) {
    if (typeof date === 'string') {
      date = new Date(date);
    }

    return `${date.getMonth() + 1}/${date.getDate()}`;
  },
  sortByDate(sort) {
    const sorts = {
      asc: ((a, b) => (a.created_at < b.created_at ? -1 : a.created_at > b.created_at ? 1 : 0)),
      desc: ((a, b) => (a.created_at < b.created_at ? 1 : a.created_at > b.created_at ? -1 : 0)),
    };

    return sorts[sort];
  },
};

export default dateHelper;
